module.exports = __webpack_public_path__ + "img/knewidea4.ccf91e49.png";